import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { CallEpisodePrescriptionService } from 'src/app/shared/services/API/orchestrator-patient/call-episode-prescription.service';
import { LocationService } from 'src/app/shared/services/API/pharmacy/location.service';
import { MedicinePresentationTypeService } from 'src/app/shared/services/API/pharmacy/medicine-presentation-type.service';
import { VerifyStorageService } from 'src/app/shared/services/API/pharmacy/verify-storage.service';
import { PrescriptionNonDispensationRequest } from 'src/app/shared/services/requests/medical-record/prescription-non-dispensation.request';
import { PrescriptionStatusEnum } from 'src/app/shared/enum/prescription-status.enum';
import { PrescriptionNonDispensationService } from 'src/app/shared/services/API/pharmacy/prescription-non-dispensation.service';
import { PrescriptionSolutionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution-medicine.struct';

@Component({
    selector: 'app-prescription-solution-non-dispensation-modal',
    templateUrl: './prescription-solution-non-dispensation-modal.component.html',
    styleUrls: ['./prescription-solution-non-dispensation-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescriptionSolutionNonDispensationModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PrescriptionSolutionNonDispensationModalComponent>,
    public verifyStorageService: VerifyStorageService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    public locationService: LocationService,
    public callEpisodePrescriptionService: CallEpisodePrescriptionService,
    public medicinePresentationTypeService: MedicinePresentationTypeService,
    public prescriptionNonDispensationService: PrescriptionNonDispensationService,
  ) { this.matDialogRef.disableClose = true; }

  public model: FormGroup;
  public prescriptionSolutionMedicineStruct: PrescriptionSolutionMedicineStruct;

  public isLoading: boolean;

  public idPrescriptionSolutionMedicine: number;

  ngOnInit(): void {
    this.isLoading = true;
    this.prescriptionSolutionMedicineStruct = this.data.prescription;
    this.idPrescriptionSolutionMedicine = this.prescriptionSolutionMedicineStruct.prescriptionSolutionMedicine.idPrescriptionSolutionMedicine;

    this.model = this.formBuilder.group({
      patientName: [{ value: this.data.patientName, disabled: true }],
      medicineName: [{ value: this.prescriptionSolutionMedicineStruct.medicineName, disabled: true }, [Validators.required]],
      nonDispensationReason: ['', [Validators.required]],
    });

    this.isLoading = false;
  }

  submit() {
    if (this.isLoading)
      return;

    if(this.model.invalid) {
      this.alertService.show('Erro', 'Você precisa informar todos os campos obrigatórios', AlertType.error);
      return;
    }

    let nonDispensationRequest: PrescriptionNonDispensationRequest = new PrescriptionNonDispensationRequest();
    nonDispensationRequest.idPrescriptionSolutionMedicine = this.idPrescriptionSolutionMedicine;
    nonDispensationRequest.idPrescriptionStatus = (this.prescriptionSolutionMedicineStruct.prescriptionSolutionMedicine.quantity && 
      (this.prescriptionSolutionMedicineStruct.quantityReleased > 0 && this.prescriptionSolutionMedicineStruct.quantityReleased < this.prescriptionSolutionMedicineStruct.prescriptionSolutionMedicine.quantity)) ? PrescriptionStatusEnum.NaoDispensadoParcialmente : PrescriptionStatusEnum.NaoDispensado;

    nonDispensationRequest.nonDispensationReason = this.model.get('nonDispensationReason').value;
    
    this.isLoading = true;
    return this.matDialogRef.close({ notDispensed: true, nonDispensationRequest: nonDispensationRequest });

  }

  clickCancel() {
    this.matDialogRef.close({ notDispensed: false });
  }
}